// JavaScript code for acf_blocks/booking-general-enquiry component
(() => {
    "use strict";

    document.querySelectorAll('[data-enquiry-form-block="general"]').forEach((block) => {
        const form = block.querySelector('[data-enquiry-form="general"]');

        // After a submission (errors or the confirmation), start keyboard and screen-reader users
        // at the top of what changed.
        if (document.querySelector('[data-enquiry-error-summary]:not(.hidden)') || !form) {
            const heading = block.querySelector('[data-enquiry-focus]');
            const invalid = block.querySelector('[aria-invalid="true"]');
            (invalid || heading)?.focus();
        }

        if (!form) return;

        const forms = window.sjmBookingForms;
        if (forms) forms.clearOnInput(block);

        // Topic-specific sections: without JS they all show; with JS only the chosen topic's do.
        // A hidden section's fields are left out of client validation (see sjmBookingForms), and the
        // server drops fields that don't apply to the topic.
        function showTopicSections() {
            const checked = form.querySelector('[data-enquiry-topic]:checked');
            const topic   = checked ? checked.value : '';

            form.querySelectorAll('[data-enquiry-topic-section]').forEach((section) => {
                section.hidden = !section.dataset.enquiryTopicSection.split(' ').includes(topic);
            });
        }

        form.addEventListener('change', (e) => {
            if (e.target.matches('[data-enquiry-topic]')) showTopicSections();
        });
        showTopicSections();

        form.addEventListener('submit', (e) => {
            const firstInvalid = forms ? forms.validate(block, form) : null;
            const summary      = block.querySelector('[data-enquiry-error-summary]');

            if (firstInvalid) {
                e.preventDefault();
                if (summary) summary.classList.remove('hidden');
                firstInvalid.focus();
                return;
            }

            const button = form.querySelector('[type="submit"]');
            if (button) button.disabled = true;
        });
    });
})();
